<template>
  <v-btn color="warning" @click="transfer()">移譲</v-btn>
</template>

<script>
export default {
  props: {
    lbOrderId: {
      type: String,
      default: "",
    },
    childUserId: {
      type: String,
      default: "",
    },

    routes: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      localLbOrderId: this.lbOrderId,
      localChildUserId: this.childUserId,
      localSwitchAdminBaseRoute: this.routes.switchAdminBaseRoute,
    };
  },

  methods: {
    transfer() {
      if (
        window.confirm(
          "個別受講コンテンツのeラーニング管理権限を移譲します。よろしいですか?\n権限を移譲すると以下の機能・情報が移行されます。\n\n・会員解約機能\n・決済情報",
        )
      ) {
        const url = new URL(
          this.localSwitchAdminBaseRoute,
          window.location.origin,
        );

        url.searchParams.append("lb_order_id", this.localLbOrderId);
        url.searchParams.append("child_user_id", this.localChildUserId);

        window.location.href = url.toString();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 750px) {
  .v-btn {
    min-width: 60px !important;
    margin: inherit;
  }
}
</style>
